/**
 * JCTCTAS-152: standalone Vite entry for modules/booking-form-modal.js --
 * split out of common.js so it only downloads on a page whose Universal
 * Text Page `content_sections` actually has a `booking_form_modal` row (see
 * inc/scripts.php's jctc_layout_conditional_scripts()). See
 * entries/hero-video-viewport.js's own doc comment for why no
 * `$(document).ready()` wrapper is needed.
 */
import initBookingFormModal from '../modules/booking-form-modal.js';

document.addEventListener('DOMContentLoaded', initBookingFormModal);
